import type { JSX } from "react";

import { useActiveMembership } from "../common/membership/ActiveMembership.js";
import { AccountMenu } from "../common/membership/AccountMenu.js";
import { ScanPage } from "../controller/pages/ScanPage.js";

/**
 * Die Kontrolleur-Shell. Dunkel, eine einzige Hauptaktion, Vollbild-Ergebnisse — der
 * Scanner ist bewusst ein anderer Ort als die Kunden-App (StyleGuide 1).
 *
 * `data-theme="dark"` (BookKing-Tokens) und `cp-theme-dark` (Tokens des UI-Kits) stehen
 * hier am Container und nicht am Dokument: die Shell ist
 * immer dunkel, unabhängig davon, was das Betriebssystem gerade bevorzugt.
 */
export function ControllerShell(): JSX.Element {
  const { active } = useActiveMembership();

  return (
    <div data-theme="dark" className="cp-theme-dark role-controller min-h-full bg-paper">
      <header className="flex items-center gap-3 border-b border-line px-4 pb-3 pt-safe-top">
        <div className="min-w-0 flex-1 pt-3">
          <p className="micro">Einlasskontrolle</p>
          <p className="truncate text-[15px] font-bold text-ink">{active?.tenantName ?? "—"}</p>
        </div>
        {/* Auch hier derselbe Wechsler: wer Feierabend hat, geht zurück in die
            Kundenansicht, ohne sich abmelden zu müssen. */}
        <span className="pt-3">
          <AccountMenu />
        </span>
      </header>

      <main className="pb-safe-bottom">
        <ScanPage />
      </main>
    </div>
  );
}
